import {
  Directive,
  effect,
  inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ExportAccessService } from './export-access.service';

/**
 * Renders its content only when the current user may export grid data (#34476).
 * Wrap every Excel/CSV export control: `<button *upsIfExportAllowed ...>`.
 */
@Directive({
  selector: '[upsIfExportAllowed]',
  standalone: true,
})
export class IfExportAllowedDirective {
  private readonly template = inject(TemplateRef<unknown>);
  private readonly container = inject(ViewContainerRef);
  private readonly exportAccess = inject(ExportAccessService);
  private rendered = false;

  constructor() {
    effect(() => {
      const allowed = this.exportAccess.exportAllowed();
      if (allowed && !this.rendered) {
        this.container.createEmbeddedView(this.template);
        this.rendered = true;
      } else if (!allowed && this.rendered) {
        this.container.clear();
        this.rendered = false;
      }
    });
  }
}
